import { theme } from '@frontend/theme';
import { TableRowActions } from '@frontend/design-system';
import { TableNoDataSmallView } from './atoms/table-no-data-small-view';
import { TableRow } from './atoms/table-row';
import { MoreButton } from './more-button';
import { ColumnOutput } from './utils';

type SmallTableViewProps<T extends object> = {
  data: T[];
  colConfig: ColumnOutput<T>[];
  actions?: TableRowActions<T>['actions'];
  customRowConfig?: {
    condition: (row: T) => boolean;
    render: (row: T) => React.ReactNode;
  };
};

export const SmallTableView = <T extends object>({
  data,
  colConfig,
  actions,
  customRowConfig,
}: SmallTableViewProps<T>) => {
  if (!data || data.length === 0) {
    return <TableNoDataSmallView />;
  }

  return (
    <div>
      {data.map((row, rowIndex) =>
        customRowConfig && customRowConfig.condition(row) ? (
          customRowConfig.render(row)
        ) : (
          <div
            key={rowIndex}
            css={{
              padding: theme.spacing(2, 1),
              borderTop: `1px solid ${theme.colors.neutral20}`,
              display: 'flex',
            }}
          >
            <TableRow data={row} colConfig={colConfig} />
            <MoreButton data={row} actions={actions} />
          </div>
        )
      )}
    </div>
  );
};
